import { makeStyles } from '@material-ui/core';

export const useTabStyles = makeStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
});
